import React, { useEffect, useState } from "react";
import Modal from "../../../atom/modal";
import ComponentMap from "../../../atom/componentmap";
import ThemedButton from "../../../atom/ThemedButton/themedButton";
// import Provision from "./provision";
import { useSelector } from "react-redux";
import * as deleteIcon from "../../../utils/lottie/deleteIcon.json";
import {
  addTenantsToAppServer,
  deleteProvisionuser,
  editProvisionUser,
  getAppServerTenants,
  getProvisionData,
  getTenant,
  getTenantDetails,
  getTenantsList,
  getToken,
  getUserRoles,
  provisionUser,
  resetPassword,
} from "../../../services/api";
import {
  actualDataToMapData,
  addAKeyValueInListItems,
  addChildrensToMapData,
  updateObjectKeyValue,
} from "../../../services/utilities";
import Notification from "../../../atom/Notification";
import Loader from "../../loader";
import regEx from "../../../config/regex";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import store from "../../../toolkit/store";
import Lottiefy from "../../../atom/lottie/lottie";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { DeleteIcon } from "../../../utils/icons/defaultIcons";
import ToggleButton from "../../../atom/toggleButton";
import Textbox from "../../../atom/textbox";
import { use } from "i18next";

function ManageTenantProvision(props: any) {
  const { setProvisionData, manageState, setManageState, type } = props;

  const activeBreadCrumbs = useSelector(
    (state: any) => state.BreadCrumbsList.brudCrubName,
  );
  const { id }: any = useParams();

  const getTelcoToken = () => {
    const state: any = store.getState();
    return state.Permissions.accountId;
  };
  const tenantInfo = useSelector((state: any) => state.tenantInfo.items);

  const handleBrudcrumbs = () => {
    let copyStore = store?.getState().BreadCrumbsList.brudCrubName;
    return copyStore[2]?.display;
  };
  const navigate = useNavigate();
  const location = useLocation();
  const currentUrl = location.pathname.split("/")[4];
  const activeIndex = useSelector((state: any) => state.button1Index.index);
  const [tenantListData, setTenantListData] = useState<any>([]);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [updatePasswordLoader, setUpdatePasswordLoader] =
    useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [passwordResetModal, setPasswordResetModal] = useState<boolean>(false);
  const [deleteUserModal, setDeleteUsertModal] = useState<any>(false);
  const [softphoneStatus, setSoftphoneStatus] = useState<any>(false);

  const callbackTenant = (value: any) => {
    // getRoles(provisionData[activeIndex]?.tenant);
  };
  const [callReport, setCallReport] = useState<any>([
    {
      title: "Email Address",
      name: "email",
      value: "",
      disabled: false,
      required: true,
      type: "email",
      regEx: regEx.email,
      errormessage: "Please enter a valid Email address",
    },
    // {
    //   title: "Tenant",
    //   name: "name",
    //   value: "",
    //   disabled: false,
    //   type: "multiselectdropdown",
    //   Callback: callbackTenant,
    //   displayProps: {
    //     label: "name",
    //     value: "name",
    //   },
    //   childrens: [],
    //   required: true,
    //   hidden: false,
    //   errormessage: "Tenant is Required",
    // },
    {
      title: "Role",
      name: "role_name",
      value: "",
      disabled: false,
      type: "dropdown",
      displayProps: {
        label: "label",
        value: "name",
      },
      childrens: [],
      required: true,
      hidden: false,
      errormessage: "Role is Required",
    },
    // {
    //   title: "Role",
    //   name: "role_name",
    //   value: "tenant_admin",
    //   layout: 3,
    //   hidden: true,
    //   required: true,
    //   errormessage: "Role is Required",
    // },
    {
      title: "First Name",
      name: "firstname",
      value: "",
      layout: 3,
      required: true,
      errormessage: "First Name is Required",
    },
    {
      title: "Last Name",
      name: "lastname",
      value: "",
      layout: 3,
      required: true,
      errormessage: "Last Name is Required",
    },

    {
      title: "Extension",
      name: "extension",
      value: "",
      layout: 3,
      required: true,
      disabled: false,
      type: "number",
      minLength: 3,
      errormessage: "Extension is Required",
    },
    {
      title: "DID",
      name: "did",
      value: "",
      layout: 3,
      required: false,
      type: "number",
      minLength: 10,
      maxLength: 12,
      errormessage: "DID is Required",
    },
    // {
    //   title: "PIN",
    //   name: "pin",
    //   value: "",
    //   layout: 3,
    //   type: "password",
    //   hidden: false,
    //   minLength: 4,
    //   maxLength: 30,
    // },
    // {
    //   name: "is_softphone_enabled",
    //   title: "Softphone",
    //   type: "checkbox",
    //   classname: "",
    // },
  ]);

  const [showPin, setShowPin] = useState([
    {
      title: "PIN",
      name: "pin",
      value: "",
      layout: 3,
      type: "password",
      hidden: false,
      regEx: regEx.number,
      minLength: 4,
      maxLength: 10,
    },
  ]);

  const [passwordData, setPasswordData] = useState([
    {
      title: "New Password",
      name: "newpassword",
      type: "password",
      value: "",
      minLength: 4,
      hidden: false,
      layout: 6,
    },
    {
      title: "Confirm New Password",
      name: "confirmpassword",
      type: "password",
      value: "",
      minLength: 4,
      hidden: false,
      layout: 6,
    },
  ]);

  const value = useSelector((state: any) => state.tenants.tenantNames);
  const provisionData = useSelector((state: any) => state.provisionedData.data);

  const onHandleClose = () => {
    navigate(-1);
  };

  const getProvision = () => {
    // getProvisionData({
    //   limit: 10,
    //   pageId: 1,
    //   sort_column: "",
    //   sort_direction: "",
    //   searchtext: "",
    // }).then((resultData: any) => {
    //   const result: any = resultData.data;
    //   setProvisionData(result);
    // });
  };
  //   const getTenants = () => {
  //     getTenantsList("")
  //       .then((resultData: any) => {
  //         const result: any = resultData.data;
  //         if (result.data && result.data.length === 0) {
  //           Notification("Failed", "Oops! Something went wrong", "danger");
  //         } else {
  //           setTenantListData(result);
  //           if (
  //             activeBreadCrumbs[2]?.display === "provisionuser" ||
  //             type === "provisionuser"
  //           ) {
  //             setCallReport(
  //               addChildrensToMapData([...callReport], result, "name"),
  //             );
  //           }
  //         }
  //       })
  //       .catch((error: any) => {
  //         console.log(error, "error");
  //         Notification("Failed", "Oops! Something went wrong", "danger");
  //       });

  //     if (activeBreadCrumbs[2]?.display === "manage" || type === "manage") {
  //       getAppServerTenants("").then((resultData: any) => {
  //         const result: any = resultData.data;
  //         result.map((node: any) => {
  //           node.name = node.displayname;
  //         });
  //         setCallReport(addChildrensToMapData([...callReport], result, "name"));
  //       });
  //     }
  //   };
  const getRoles = (tenantId?: string) => {
    getUserRoles("", tenantId).then((resultData: any) => {
      let result: any = resultData.data;
      result = result.map((node: any) => {
        node.role = node?.uuid;
        node.label = node.name.replace(/_/g, " ");
        node.label = node.label.charAt(0).toUpperCase() + node.label.slice(1);

        return node;
      });

      setCallReport(
        addChildrensToMapData([...callReport], result, "role_name"),
      );
    });
  };

  const onSave = (onSaveResult: any) => {
    console.log("clicksave", onSaveResult);
    setButtonLoader(true);
    const tenant = tenantListData.find(
      (item: any) => item.sil_tenant_id === callReport[1].value?.sil_tenant_id,
    );

    if (showPin[0].value.length !== 0 && showPin[0].value.length < 4) {
      Notification("Failed", "Pin should be minimum 4 digits", "danger");
      setButtonLoader(false);
    } else {
      const payload = {
        displayname: tenantInfo?.name,
        telco_id: `${getTelcoToken()}`,
        name: tenantInfo?.name?.toLowerCase()?.replace(/\s/g, ""),
        sil_id: tenantInfo?.sil_id,
        sil_tenant_id: String(tenantInfo?.sil_tenant_id),
        sil_tenant_url: tenantInfo?.sil_tenant_url,
        is_softphone_enabled: softphoneStatus,
      };
      console.log("onsavee", onSaveResult, "payload", payload, getToken());

      console.log(
        "callReport",
        callReport,
        "onSaveResult",
        onSaveResult,
        callReport[1]?.childrens?.filter(
          (node: any) => node.name === onSaveResult.role_name.name,
        )[0]?.uuid,
      );

      addTenantsToAppServer(payload)
        .then((resultData: any) => {
          const result: any = resultData.data;
          return provisionUser(
            {
              ...onSaveResult,
              role: callReport[1]?.childrens?.filter(
                (node: any) => node.name === onSaveResult.role_name.name,
              )[0]?.uuid,
              is_softphone_enabled: softphoneStatus,
              pin: showPin[0]?.value,
              role_name: onSaveResult.role_name.name,
            },

            getToken(),
          );
        })
        .then((resultData: any) => {
          setButtonLoader(true);

          const result: any = resultData.data;
          if (!resultData?.success) {
            let msg =
              resultData?.message === "email already exist"
                ? "email already exists"
                : resultData?.message;

            Notification(
              "Failed",
              msg?.charAt(0).toUpperCase() + msg.slice(1),
              "danger",
            );
            if (
              resultData?.message === "Softphone is disabled for this tenant"
            ) {
              setSoftphoneStatus(false);
            }
            getProvision();
            setButtonLoader(false);
          } else {
            Notification("Success", "User provisioned successfully", "success");
            getProvision();
            navigate(-1);
            setButtonLoader(false);
          }
        });
    }
  };
  const findUUID = (data: any) => {
    const foundObject = data.find(
      (item: any) =>
        item.sil_tenant_id === callReport[1].value.sil_tenant_id.toString(),
    );
    // console.log(foundObject, "foundObjectfoundObject");
    return foundObject ? foundObject.uuid : "Not found";
  };

  const onHandleDeleteUser = (result: any) => {
    // console.log(result, "result");
    setLoader(true);
    deleteProvisionuser(
      "",
      provisionData[activeIndex].tenant,
      provisionData[activeIndex].uuid,
    )
      .then((resultData: any) => {
        if (resultData?.success) {
          const result: any = resultData.data;
          setDeleteUsertModal("deleteUsersuccess");
          setTimeout(() => {
            setDeleteUsertModal(false);
            navigate(-1);
          }, 2000);
          setLoader(false);
          Notification("Success", "User Deleted successfully", "success");
        } else {
          Notification(
            "Failed",
            "User deletion failed. Please try again Later",
            "danger",
          );
          setLoader(false);
        }
      })
      .catch((error: any) => {
        Notification(
          "Failed",
          "User deletion failed. Please try again Later",
          "danger",
        );
        setLoader(false);
      });
  };

  const onHandleUpdate = (onSaveResult: any) => {
    setButtonLoader(true);

    if (showPin[0].value.length !== 0 && showPin[0].value.length < 4) {
      Notification("Failed", "Pin should be minimum 4 digits", "danger");
      setButtonLoader(false);
    } else {
      editProvisionUser(
        {
          ...onSaveResult,
          role: callReport[1].childrens.filter(
            (node: any) => node.name === onSaveResult.role_name,
          )[0].uuid,
          is_softphone_enabled: softphoneStatus,
          pin: showPin[0]?.value,
        },
        provisionData[activeIndex].tenant,
        provisionData[activeIndex].uuid,
      )
        .then((resultData: any) => {
          const result: any = resultData.data;
          if (!resultData.success) {
            Notification(
              "Failed",
              `${
                resultData?.message
                  ? resultData?.message
                  : "Oops! Something went wrong"
              }`,
              "danger",
            );
            if (
              resultData?.message === "Softphone is disabled for this tenant"
            ) {
              setSoftphoneStatus(false);
            }
            setButtonLoader(false);
          } else {
            Notification("Success", "Updated successfully", "success");
            navigate(-1);
            setButtonLoader(false);
          }
        })
        .catch((error: any) => {
          setButtonLoader(false);
          Notification("Error", "Update Failed", "danger");
        });
    }
  };

  const onHandleResetPassword = () => {
    setPasswordResetModal(!passwordResetModal);
    let copyPasswordData = passwordData;
    copyPasswordData[0].value = "";
    copyPasswordData[1].value = "";
    setPasswordData(copyPasswordData);
  };

  const onUpdatePassword = () => {
    setUpdatePasswordLoader(true);
    if ((passwordData[0].value && passwordData[1].value) === "") {
      Notification("Failed", "Password fields cannot be empty", "danger");
      setUpdatePasswordLoader(false);
    } else {
      if (passwordData[0].value !== passwordData[1].value) {
        Notification("Failed", "Password Mismatched!", "danger");
        setUpdatePasswordLoader(false);
      } else {
        let payload = {
          email: provisionData[activeIndex]?.email,
          password: passwordData[0].value,
        };
        resetPassword(payload, provisionData[activeIndex]?.uuid)
          .then((resultData: any) => {
            const result: any = resultData.data;
            Notification("Success", "Password updated successfully", "success");
            setPasswordResetModal(false);
            setUpdatePasswordLoader(false);
          })
          .catch((error: any) => {
            setUpdatePasswordLoader(false);
            Notification(
              "Error",
              "Password update failed. Try again later",
              "danger",
            );
          });
      }
    }
  };

  const handleChecked = () => {
    setSoftphoneStatus(!softphoneStatus);
  };

  // const getTenantInfo = () => {
  //   getTenant(getToken()).then((resultData: any) => {
  //     // const result: any = resultData.data;
  //     // store.dispatch(setTenantInfo(result));
  //     console.log("Tenant Info:", resultData.data);
  //   });
  // };

  useEffect(() => {
    // getTenantInfo();
    getRoles(provisionData[activeIndex]?.tenant);
    if (activeBreadCrumbs?.length === 3) {
      if (tenantListData?.length === 0) {
        // getTenants();
      }
      if (activeBreadCrumbs[2]?.display === "manage" || type === "manage") {
        getRoles(provisionData[activeIndex].tenant);

        let copy = { ...provisionData[activeIndex] };
        Object.preventExtensions(copy);

        let newName = provisionData[activeIndex]?.owner;
        let updatedCopy = { ...copy, name: newName };

        setSoftphoneStatus(updatedCopy?.is_softphone_enabled);
        setCallReport(actualDataToMapData([...callReport], updatedCopy));
      }
    }
    const copyCallReports = [...callReport];
    console.log("activeBreadCrumbs[2]", activeBreadCrumbs[2]);

    if (activeBreadCrumbs[2]?.display === "manage" || type === "manage") {
      updateObjectKeyValue([...copyCallReports], "name", "disabled", true);
      updateObjectKeyValue([...copyCallReports], "email", "disabled", true);
      updateObjectKeyValue([...copyCallReports], "extension", "disabled", true);

      updateObjectKeyValue([...copyCallReports], "name", "type", "text");
      copyCallReports[1].displayProps.value = "name";
      updateObjectKeyValue(
        [...showPin],
        "pin",
        "hidden",
        !provisionData[activeIndex]?.pin_required,
      );
      // updateObjectKeyValue([...callReport], "name", "displayProps.value", true);
    } else if (
      activeBreadCrumbs[2]?.display === "provisionuser" ||
      type === "provisionuser"
    ) {
      updateObjectKeyValue([...copyCallReports], "name", "disabled", false);
      updateObjectKeyValue([...copyCallReports], "email", "disabled", false);
      updateObjectKeyValue(
        [...copyCallReports],
        "extension",
        "disabled",
        false,
      );
      updateObjectKeyValue(
        [...copyCallReports],
        "name",
        "type",
        "multiselectdropdown",
      );
      updateObjectKeyValue(
        [...copyCallReports],
        "extension",
        "disabled",
        false,
      );
      updateObjectKeyValue([...showPin], "pin", "hidden", false);

      copyCallReports[1].displayProps.value = "sil_tenant_id";
    }
    setCallReport([...copyCallReports]);
  }, [activeBreadCrumbs]);

  return (
    <div data-testid="manageProvision">
      {/* {console.log(callReport, "managee")} */}
      {/* {manageState === "manage" || manageState === "newUserProvision" ? ( */}
      <>
        {/* {!loader ? ( */}
        <Modal
          title={`${
            activeBreadCrumbs[2]?.display === "manage" || type === "manage"
              ? "Edit Provision User"
              : "Provision User"
          }`}
          closeEvent={() => {
            onHandleClose();
          }}
        >
          <div className="w-[540px] smallPicker">
            <ComponentMap data={callReport} setData={setCallReport} />
          </div>
          <div className="flex items-center pl-2.5 text-[17px] mt-1">
            <div>SoftPhone</div>
            <div>
              {" "}
              <ToggleButton
                click={() => handleChecked()}
                checked={softphoneStatus}
              />
            </div>
          </div>

          {softphoneStatus && (
            <div
              className={`pt-3 smallPicker ${
                type === "manage" &&
                !provisionData[activeIndex]?.pin_required &&
                "hidden"
              }`}
            >
              <ComponentMap data={showPin} setData={setShowPin} />
            </div>
          )}
          {activeBreadCrumbs[2]?.display === "manage" || type === "manage" ? (
            <div className="flex justify-between px-1">
              <div className="h-full py-4 flex  mt-4 ">
                <ThemedButton
                  children={"Delete User"}
                  icon="custom"
                  theme="secondary"
                  valiData={callReport}
                  change={setCallReport}
                  click={() => setDeleteUsertModal("deleteUser")}
                />
              </div>
              <div className=" h-full py-4 flex  mt-4 ">
                <ThemedButton
                  children={"Reset Password"}
                  icon="custom"
                  theme="secondary"
                  valiData={callReport}
                  change={setCallReport}
                  click={onHandleResetPassword}
                />
                <ThemedButton
                  children={"Save Changes"}
                  icon="custom"
                  theme="primary"
                  valiData={callReport}
                  change={setCallReport}
                  click={onHandleUpdate}
                  loading={buttonLoader}
                />
              </div>
            </div>
          ) : activeBreadCrumbs[2]?.display === "provisionuser" ||
            type === "provisionuser" ? (
            <div className=" w-full h-full flex items-baseline justify-end mt-4 -ml-1.5">
              <ThemedButton
                children={"Add"}
                icon="custom"
                valiData={callReport}
                change={setCallReport}
                theme="primary"
                click={onSave}
                loading={buttonLoader}
              />
            </div>
          ) : (
            ""
          )}
        </Modal>
        {passwordResetModal && (
          <Modal
            title={"Reset Password"}
            closeEvent={() => {
              setPasswordResetModal(false);
            }}
          >
            <div className="mt-2 relative w-[540px] smallPicker">
              <ComponentMap data={passwordData} setData={setPasswordData} />
            </div>
            <div className=" w-full h-full flex items-baseline justify-end mt-8 -ml-1">
              <ThemedButton
                children={"Update Password"}
                icon="custom"
                theme="primary"
                valiData={passwordData}
                change={setPasswordData}
                click={onUpdatePassword}
                loading={updatePasswordLoader}
              />
            </div>
          </Modal>
        )}
        {deleteUserModal ? (
          <Modal
            title={"Delete User"}
            icon={DeleteIcon()}
            closeEvent={() => {
              setDeleteUsertModal(false);
            }}
          >
            {deleteUserModal === "deleteUser" ? (
              <div>
                <div className="px-2">
                  Are you sure you want to delete the user ?
                </div>
                <div className=" w-full h-full flex items-baseline justify-end mt-8 -ml-1">
                  <ThemedButton
                    children={"Cancel"}
                    theme="ternary"
                    click={() => setDeleteUsertModal(false)}
                    // loading={loader}
                  />
                  <ThemedButton
                    children={"Delete"}
                    theme="primary"
                    click={onHandleDeleteUser}
                    loading={loader}
                  />
                </div>
              </div>
            ) : deleteUserModal === "deleteUsersuccess" ? (
              <div className="w-full h-full flex justify-center items-center">
                <Lottiefy
                  loop={false}
                  json={deleteIcon}
                  height={100}
                  width={100}
                />
              </div>
            ) : null}
          </Modal>
        ) : null}
      </>
      {/* ) : null} */}
    </div>
  );
}

export default ManageTenantProvision;
